export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <svg width="38" height="38" viewBox="0 0 64 64" aria-hidden="true" className="shrink-0">
        <rect width="64" height="64" rx="15" fill="#0F2137" stroke="#00B4D8" strokeOpacity="0.4" />
        <path
          d="M32 9c8.5 10.6 12.5 16.9 12.5 23.7a12.5 12.5 0 1 1-25 0C19.5 25.9 23.5 19.6 32 9z"
          fill="#00B4D8"
        />
        <path
          d="M24.6 32.8c-.4 1.7-.1 3.5 1 5 1.8 2.5 5.4 3.2 7.9 1.4"
          fill="none"
          stroke="#0B192C"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
        <path d="M17 46h30M21 52h22" stroke="#F8FAFC" strokeWidth="3" strokeLinecap="round" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display font-extrabold text-xl tracking-tight text-white">
            Puțul tău
          </span>
          <span className="block mt-1 text-[10px] font-mono uppercase tracking-[0.22em] text-white/50">
            Foraje · București-Ilfov
          </span>
        </span>
      )}
    </span>
  );
}
